// 1:7:CounterfeitFront-PiratesAlert/src/views/admin/testProducts/components/AddTestPurchase.js
import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
    HStack,
  Flex,
} from "@chakra-ui/react";

export default function AddTestPurchase({ onClose, setFailureAlert, setSuccessAlert }) {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const userInfo = JSON.parse(localStorage.getItem("PAuser"));
  const [submitting, setSubmitting] = useState(false);
  const reportRef = useRef(null);
  const invoiceRef = useRef(null);
  const today = new Date().toISOString().split("T")[0];
  const [formData, setFormData] = useState({
    title: "",
    keyword: "",
    keyword_id: "",
    platform_name: "",
    platform_id: "",
    prod_code: "",
    seller_name: "",
    selling_price: 0,
    mrp: 0,
    manufacturer: "",
    test_purchase_status: 1,
    prod_link: "",
    image_link: "",
    date: today,
  });
  const [report, setReport] = useState([]);
  const [invoice, setInvoice] = useState([]);
  const [keywordsOptions, setKeywordsOptions] = useState([]);
  const [platformsOptions, setPlatformsOptions] = useState([]);
  
  const [alertTimeout, setAlertTimeout] = useState(null);

  useEffect(() => {
    return () => {
      if (alertTimeout) {
        clearTimeout(alertTimeout);
      }
    };
  }, [alertTimeout]);

  const handleSuccessAlert = async (alertMessage) => {
    if (alertTimeout) {
      clearTimeout(alertTimeout);
    }
    setSuccessAlert(alertMessage);
    const timeout = setTimeout(() => {
      setSuccessAlert("");
    }, 2000);
    setAlertTimeout(timeout);
  };
  
  const handleFailureAlert = async (alertMessage) => {
    if (alertTimeout) {
      clearTimeout(alertTimeout);
    }
    setFailureAlert(alertMessage);
    const timeout = setTimeout(() => {
      setFailureAlert("");
    }, 2000);
    setAlertTimeout(timeout);
  };

  const fetchKeywordsAndPlatforms = async () => {
    try {
      const [keywordsResponse, platformsResponse] = await Promise.all([
        fetch(`${backendUrl}/api/keyword/getKeywordsForFilter/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id,
          }),
        }),
        fetch(`${backendUrl}/api/platforms/Filter`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id,
          }),
        }),
      ]);

      const keywordsJson = await keywordsResponse.json();
      const platformsJson = await platformsResponse.json();

      if (keywordsResponse.ok) {
        const formattedKeywords = keywordsJson.map((keyword) => ({
          id: keyword.id,
          name: keyword.name,
        }));
        setKeywordsOptions(formattedKeywords);
      } else if (keywordsResponse.status === 400) {
        alert(keywordsJson.message);
      }

      if (platformsResponse.ok) {
        const formattedPlatforms = platformsJson.map((platform) => ({
          id: platform.id,
          name: platform.platform_name,
        }));
        setPlatformsOptions(formattedPlatforms);
      } else if (platformsResponse.status === 400) {
        alert(platformsJson.message);
      }
    } catch (e) {
      console.log("error in fetchKeywordsAndPlatforms", e);
    }
  };
  
    useEffect(() => {
      fetchKeywordsAndPlatforms();
    }, []);

    
  
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]:
        name === "selling_price" || name === "mrp" ? Number(value) : value,
    }));

    if (name === "platform_id") {
      const selectedPlatform = platformsOptions.find(option => option.id === Number(value));
      if (selectedPlatform) {
        setFormData(prevState => ({
          ...prevState,
          platform_name: selectedPlatform.name, // Store the platform name
        }));
      }
    }
    if (name === "keyword_id") {
      const selectedKeyword = keywordsOptions.find(option => option.id === Number(value));
      if (selectedKeyword) {
        setFormData((prevState) => ({
          ...prevState,
          keyword: selectedKeyword.name, // Store the keyword
        }));
      }
    }
  };
  
  const refs = {
    invoice: invoiceRef,
    report: reportRef,
  };

  const handleButtonClick = (type) => {
    refs[type].current.click();
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === "report") {
      setReport(files[0]);
    } else if (name === "invoice") {
      setInvoice(files[0]);
    }
  };

  const handleSubmit = async () => {
    try {
      setSubmitting(true)
      const formDataToSend = new FormData();

      formDataToSend.append("report", report);
      formDataToSend.append("invoice", invoice);

      formDataToSend.append("details", JSON.stringify(formData));
      formDataToSend.append("uid", userInfo?.message?.result.id);
      const response = await fetch(`${backendUrl}/api/test/addTestPurchase`, {
        method: "POST",
        body: formDataToSend,
      });

      const json = await response.json();

      if (!response.ok) {
        console.log(
          `Error saving changes: ${json.message || "Unknown error"}`
        );
        return;
      }
      handleSuccessAlert("Test Purchase Added Successfully.")
    } catch (e) {
      console.log("Error saving changes. Please try again");
      handleFailureAlert("Test Purchase could not be added.");
    } finally {
      setSubmitting(false);
      onClose();
    }
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      size="xl"
      scrollBehavior="inside"
      autoFocus
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Test Purchase</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <form>
            <HStack spacing={4} mb={4}>
              <FormControl>
                <FormLabel>Title</FormLabel>
                <Input
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Keyword</FormLabel>
                <Select
                  name="keyword_id"
                  value={formData.keyword_id}
                  onChange={handleChange}
                >
                  <option value="">Select Keyword</option>
                  {keywordsOptions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </HStack>
            <HStack spacing={4} mb={4}>
              <FormControl>
                <FormLabel>Product Code</FormLabel>
                <Input
                  name="prod_code"
                  value={formData.prod_code}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Platform</FormLabel>
                <Select
                  name="platform_id"
                  value={formData.platform_id}
                  onChange={handleChange}
                >
                  <option value="">Select Platform</option>
                  {platformsOptions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </HStack>
            <HStack spacing={4} mb={4}>
              <FormControl>
                <FormLabel>Product Link</FormLabel>
                <Input
                  name="prod_link"
                  value={formData.prod_link}
                  onChange={handleChange}
                />
              </FormControl>
            </HStack>
            <HStack spacing={4} mb={4}>
              <FormControl>
                <FormLabel>Image Link</FormLabel>
                <Input
                  name="image_link"
                  value={formData.image_link}
                  onChange={handleChange}
                />
              </FormControl>
            </HStack>
            <HStack spacing={4} mb={4}>
              <FormControl>
                <FormLabel>Seller Name</FormLabel>
                <Input
                  name="seller_name"
                  value={formData.seller_name}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Manufacturer</FormLabel>
                <Input
                  name="manufacturer"
                  value={formData.manufacturer}
                  onChange={handleChange}
                />
              </FormControl>
            </HStack>
            <HStack spacing={4} mb={4}>
              <FormControl>
                <FormLabel>Selling Price</FormLabel>
                <Input
                  name="selling_price"
                  value={formData.selling_price}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>MRP</FormLabel>
                <Input
                  name="mrp"
                  value={formData.mrp}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Date</FormLabel>
                <Input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  min="2020-01-01"
                  max={new Date().toISOString().split("T")[0]}
                />
              </FormControl>
            </HStack>
            <HStack spacing={4} mb={4}>
              <Button
                variant="outline"
                onClick={() => handleButtonClick("report")}
              >
                Upload Report
              </Button>
              <p>{report?.name}</p>
            </HStack>
            <HStack spacing={4} mb={4}>
              <Button
                variant="outline"
                onClick={() => handleButtonClick("invoice")}
              >
                Upload Invoice
              </Button>
              <p>{invoice?.name}</p>
            </HStack>

            <FormControl my={4}>
              <Input
                type="file"
                accept="application/pdf"
                onChange={handleFileChange}
                name="report"
                ref={reportRef}
                display="none"
              />
              <Input
                type="file"
                accept="application/pdf"
                onChange={handleFileChange}
                name="invoice"
                ref={invoiceRef}
                display="none"
              />
            </FormControl>
            <Flex justify="center" m={4}>
              <Button onClick={handleSubmit} isLoading={submitting} colorScheme="blue">
                Submit
              </Button>
            </Flex>
          </form>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}